import ItemsList from './ItemsList';
import { withI18n } from 'react-i18next';

export default withI18n()(ItemsList);
